export default {
  agreed: 'Accettato',
  searchStatement: 'Termini di utilizzo della ricerca',
  noData: 'Nessun altro dato',
  starts: 'Stella',
  searching: 'Ricerca in corso',
  searchService: 'Cerca termini di utilizzo',
  filter: {
    performanceQuality: 'Qualità delle prestazioni',
    comprehensiveExperienceScore: 'Punteggio esperienza complessivo',
    fourStartDown: 'Meno di quattro stelle',
    certifiedFactory: 'Fabbrica certificata',
    dayYield: 'Tasso di rendimento in 24 ore',
    doubleDayYield: 'Tasso di rendimento in 48 ore',
    performanceGuarantee: 'Garanzia di prestazione',
    dayShipments: 'Spedizione in giornata',
    strictSelect: 'Selezione rigorosa',
    disStrictSelect: 'Selezione rigorosa della distribuzione',
    dayShip: 'Consegna in 24 ore',
    doubleDayShip: 'Consegna in 48 ore',
    sevenDayNoReason: 'Sette giorni senza motivo',
    oneIssuing: 'Supporta la spedizione di un singolo pezzo',
    onePostIssuing: 'Supporta la spedizione gratuita (spedizione gratuita per un singolo pezzo)',
    sevenDayNew: '7 giorni per i nuovi prodotti',
    thirtyDayNew: '30 giorni per i nuovi prodotti',
    wordStrictSelect: 'Selezione rigorosa globale',
    isSelect: 'Piattaforme di selezione transfrontaliere',
    priceSort: 'Ordina per prezzo',
    compositeSort: 'Ordinamento generale',
    up: 'Riduci',
    reset: 'Ripristina',
    moreFilters: 'Più filtri',
    bestMatch: 'Migliore corrispondenza',
    saleHighToLow: 'Vendite: Dal più alto al più basso',
    saleLowToHigh: 'Vendite: Dal più basso al più alto',
    priceHighToLow: 'Prezzo: Dal più alto al più basso',
    priceLowToHigh: 'Prezzo: Dal più basso al più alto',
    fastToSlow: 'Tempo di spedizione: Dal più veloce al più lento',
    slowToFast: 'Tempo di spedizione: Dal più lento al più veloce',
  },
}
